<ng-container *transloco="let t; read: 'project.spotlight-dashboard-ideas-dialog'">
  <xi-basic-tile [hasTopBar]="false" [isInteractive]="false" [stretch]="true" [padding]="22">
    <div slot="children">
      <div class="spotlight-dashboard-ideas-dialog">
        @if (step() === 'collection') {
          <div class="spotlight-dashboard-ideas-dialog__header">
            <h2 class="kxi-text-large kxi-text-600">
              {{ isChatMode() ? t('chat-title') : t('title') }}
            </h2>
            <p class="spotlight-dashboard-ideas-dialog__subtitle kxi-text-normal">
              {{ isChatMode() ? t('chat-collection-subtitle') : t('collection-subtitle') }}
            </p>
          </div>

          <div class="spotlight-dashboard-ideas-dialog__content">
            <div class="spotlight-dashboard-ideas-dialog__dropdown-container">
              <xi-dropdown
                select="single"
                color="orca"
                [label]="t('dropdown-label')"
                [placeholder]="t('dropdown-placeholder')"
                [stretch]="true"
                [data]="collectionDropdownOptions()"
                [value]="selectedCollection()?.id"
                (onValueChange)="onCollectionDropdownChange($event.detail.selected)"
              ></xi-dropdown>
            </div>
          </div>

          <div class="spotlight-dashboard-ideas-dialog__actions">
            <xi-default-button
              [text]="t('cancel')"
              fill="text"
              buttonSize="small"
              (onClick)="onCancel()"
            ></xi-default-button>
            @if (isChatMode()) {
              <xi-default-button
                [text]="t('begin-chat')"
                buttonSize="small"
                [disabled]="!selectedCollection()"
                (onClick)="onBeginChatClick()"
              ></xi-default-button>
            } @else {
              <xi-default-button
                [text]="t('next')"
                buttonSize="small"
                [disabled]="!selectedCollection()"
                (onClick)="proceedToIdeas()"
              ></xi-default-button>
            }
          </div>
        }

        @if (step() === 'ideas') {
          <div class="spotlight-dashboard-ideas-dialog__header">
            <h2 class="kxi-text-large kxi-text-600">{{ t('title') }}</h2>
            @if (!isGenerating()) {
              <p class="spotlight-dashboard-ideas-dialog__subtitle kxi-text-normal">
                {{ t('ideas-subtitle') }}
              </p>
            }
          </div>

          <div>
            @if (isGenerating()) {
              <div class="spotlight-dashboard-ideas-dialog__content">
                <p class="spotlight-dashboard-ideas-dialog__subtitle kxi-text-normal">
                  {{ t('generating-subtitle') }}
                </p>
                <ul class="spotlight-dashboard-ideas-dialog__stages">
                  @for (stage of generationStages; let i = $index; track stage.id) {
                    <li
                      class="spotlight-dashboard-ideas-dialog__stage"
                      [class.spotlight-dashboard-ideas-dialog__stage--active]="
                        currentStageIndex() === i
                      "
                      [class.spotlight-dashboard-ideas-dialog__stage--done]="
                        currentStageIndex() > i
                      "
                    >
                      <span
                        class="spotlight-dashboard-ideas-dialog__stage-marker"
                        aria-hidden="true"
                      >
                        @if (currentStageIndex() > i) {
                          ✓
                        }
                      </span>
                      <span class="kxi-text-normal">{{ t(stage.key) }}</span>
                    </li>
                  }
                </ul>
              </div>
            } @else if (isLoadingIdeas()) {
              <div class="spotlight-dashboard-ideas-dialog__content">
                <div class="spotlight-dashboard-ideas-dialog__loading">
                  <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
                  <span class="kxi-text-normal">
                    {{ t('loading') }}
                  </span>
                </div>
              </div>
            }

            @if (!isLoadingIdeas() && !isGenerating()) {
              <div class="spotlight-dashboard-ideas-dialog__content">
                <div class="spotlight-dashboard-ideas-dialog__grid">
                  @for (idea of ideas(); track $index) {
                    <button
                      type="button"
                      class="spotlight-dashboard-ideas-dialog__idea-card"
                      [class.spotlight-dashboard-ideas-dialog__idea-card--selected]="
                        selectedPrompt() === idea.prompt
                      "
                      (click)="onSelectPrompt(idea)"
                    >
                      <h3 class="spotlight-dashboard-ideas-dialog__idea-title">{{ idea.title }}</h3>
                      <p class="spotlight-dashboard-ideas-dialog__idea-description">
                        {{ idea.description }}
                      </p>
                    </button>
                  }

                  <div
                    class="spotlight-dashboard-ideas-dialog__idea-card spotlight-dashboard-ideas-dialog__idea-card--custom"
                  >
                    <xi-text-area
                      class="spotlight-dashboard-ideas-dialog__textarea"
                      [label]="t('custom-instruction-title')"
                      [placeholder]="t('custom-instruction-placeholder')"
                      [height]="120"
                      [ngModel]="customInstruction()"
                      (ngModelChange)="onCustomInstructionChange($event)"
                    ></xi-text-area>
                  </div>
                </div>
              </div>
            }
          </div>

          <div class="spotlight-dashboard-ideas-dialog__actions">
            @if (showCollectionStep() && !isGenerating()) {
              <xi-default-button
                [text]="t('edit-selection')"
                fill="text"
                buttonSize="small"
                (onClick)="goBackToCollections()"
              ></xi-default-button>
            } @else if (!isGenerating()) {
              <xi-default-button
                [text]="t('cancel')"
                fill="text"
                buttonSize="small"
                (onClick)="onCancel()"
              ></xi-default-button>
            }

            @if (isGenerating()) {
              <xi-default-button
                [text]="t('minimize')"
                fill="text"
                buttonSize="small"
                (onClick)="onMinimize()"
              ></xi-default-button>
            }

            @if (!isGenerating()) {
              <xi-default-button
                class="spotlight-dashboard-ideas-dialog__cta"
                [text]="t('generate')"
                buttonSize="small"
                [disabled]="!canGenerate"
                (onClick)="onGenerateClick()"
              ></xi-default-button>
            }
          </div>
        }
      </div>
    </div>
  </xi-basic-tile>
</ng-container>
